import type { GraphpadWidgetConfig } from '../graphpad.model';

/**
 * Quadratic exploration preset using standard form (ax² + bx + c).
 * Same as quadratic-exploration but initialized with standard form params.
 */
export const QUADRATIC_EXPLORATION_ABC_PRESET: GraphpadWidgetConfig = {
  id: 'quadratic-exploration-abc',
  type: 'graphpad',
  params: {
    f: { type: 'quadratic', params: { a: 1, b: 0, c: -4 } },
    'f-translate': { type: 'handle', params: { of: 'f', behavior: 'translate' } },
    'f-roots': { type: 'roots', params: { of: 'f' } },
    'f-derivative': { type: 'derivative', params: { of: 'f' } },
    'f-axis': { type: 'axisOfSymmetry', params: { of: 'f' } },
  },
  display: {
    coordinateSystem: {
      boundingbox: { xStart: -10, xEnd: 10, yStart: -10, yEnd: 10 },
      grid: { type: 'lines', visible: true },
      axes: true,
    },
    elements: {
      f: {
        curve: {
          label: { text: 'f(x) = ax² + bx + c', position: 'topRight' },
        },
      },
      'f-translate': {
        point: {
          label: { text: 'Drag me!', position: 'topRight' },
        },
      },
      'f-roots': {
        point: {
          color: 'indigo',
          label: { contentVariant: 'coord', position: 'bottom', color: 'indigo' },
        },
      },
      'f-derivative': { curve: { color: 'neutral', strokeWidth: 2 } },
      'f-axis': { line: { color: 'amber', dash: 2 } },
    },
  },
};
